import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {ProfileMode} from '../../app.constants';
import {ProcessInstance} from '../workflow/workflow-v2.interface';
import {getWorkflowKey, WorkflowV2Service} from '../workflow/workflow-v2.service';


const HiringStatus = [
  {
    begindate: '1970-01-01',
    isDated: false,
    enddate: '3000-01-01',
    groupName: 'HiringStatus',
    values: {
      HiringStatus: {
        type: 'LIST',
        value: 'InitiatedViaMSS',
        transId: 'Initiated via MSS'
      }
    }
  }
];

@Injectable()
export class HireService {

  constructor(private workflowV2Service: WorkflowV2Service) {
  }

  public createUpdatePersonalInfoWorkflowV2(request: { [key: string]: any },
                                            workflowName: string,
                                            cliRegId: number,
                                            firstName: string,
                                            lastName: string,
                                            cliEmpId?: number,
                                            profileMode?: ProfileMode
                                          ): Observable<ProcessInstance> {
    const workflowKey = getWorkflowKey(workflowName, cliRegId);
    return this.workflowV2Service.startProcessInstance(workflowKey,
      {
        request: {
          ...request,
          HiringStatus
        },
        cliEmpId,
        firstName,
        lastName
      }, false, profileMode);
  }
}
